import { SortDirection } from '../utils/tableHelper';

import { DATE_TYPE_TOTAL } from '../components/tables/reports/consts';
import { ORDER_TYPE_DROPSHIP, ORDER_TYPE_MARKETPLACE } from './orderTypes';

export const DATA_TYPE_GMV = {
  value: 'gmv',
  label: 'Sales',
};

export const DATA_TYPE_UNITS = {
  value: 'unit_count',
  label: 'Units',
};

export const CURRENCY = {
  USD: 'usd',
  EUR: 'eur',
};

export const AnalyticsOrderType = {
  SALES: 'sales',
  ORDERS: 'orders',
  UNITS: 'units',
};

/*
 * mainly used as a key for getMetricValueBasedOnCurrentOrderType()
 */
export const ANALYTICS_METRIC_GRAPH_TYPE = {
  GMV: 'gmv',
  TOTAL_NET_SALES: 'total_net_sales',
  AOV: 'aov',
  CANCELLATIONS: 'cancellations',
  RETURNS: 'returns',
};

export const CURRENCIES = [
  { value: CURRENCY.EUR, label: 'EUR', symbol: '€' },
  { value: CURRENCY.USD, label: 'USD', symbol: '$' },
];

export const DEFAULT_SUPPORTED_CURRENCIES = [CURRENCY.USD, CURRENCY.EUR];

export const DEFAULT_REPORT_STATE = {
  data: null,
  dateType: DATE_TYPE_TOTAL,
  canLoadData: false,
  totalCount: 0,
  table: {
    page: 0,
    rowsPerPage: 10,
  },
  sort: {
    column: 'date',
    direction: SortDirection.DESC,
  },
  search: '',
};

export const NAVIGATION_PANEL_DISPLAY_TYPE = {
  COMPACT: 'COMPACT',
  FULL: 'FULL',
};

export const DOWNLOAD_REPORT_FINISHED = 'DOWNLOAD_REPORT_FINISHED';
export const DOWNLOAD_REPORT_CLOSED = 'DOWNLOAD_REPORT_CLOSED';

export const ANALYTICS_DIALOGS = {
  SEND_REPORT_NOTIFICATION: 'SEND_REPORT_NOTIFICATION',
};

export const orderTypeOptions = [
  {
    value: ORDER_TYPE_DROPSHIP,
    label: `Dropship`,
  },
  {
    value: ORDER_TYPE_MARKETPLACE,
    label: `MarketPlace`,
  },
];

export const ORDER_TYPE_OPTIONS = [ORDER_TYPE_DROPSHIP, ORDER_TYPE_MARKETPLACE];
